<template>
  <div class="approval">
    <div class="sift">
      <div class="title">协同定义查询</div>
      <div class="inquire">
        <el-form :inline="true" :model="formInline" class="demo-form-inline" size="small">
          <el-form-item label="名称">
            <strong slot="label">名称</strong>
            <el-input
              v-model="formInline.name"
              placeholder="请输入名称"
              clearable
              @keyup.enter.native="inquire"
              @clear="inquire"
            ></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" icon="el-icon-search" @click="inquire" style="background:#0C75E5">查询</el-button>
            <el-button icon="el-icon-refresh" @click="reset">重置</el-button>
          </el-form-item>
        </el-form>
        <el-button type="primary" plain icon="el-icon-plus" @click="handleAdd('cooperate')" size="small">新建</el-button>
        <el-button icon="el-icon-edit-outline" plain type="success" :disabled="ids.length != 1" @click="handleEdit('cooperate')" size="small">编辑</el-button>
        <el-button type="danger" plain size="small" icon="el-icon-delete" :disabled="!ids.length" @click="handleDel('cooperate')">删除</el-button>
      </div>
    </div>
    <div class="main">
      <div class="title">协同定义列表</div>
      <el-table
        :data="tableData"
        tooltip-effect="dark"
        style="width: 100%"
        @selection-change="handleSelectionChange"
        :header-cell-style="{ background: '#F9F9FB', color: '#606266' }"
        v-loading="loading"
      >
        <el-table-column type="selection" width="55"> </el-table-column>
        <el-table-column prop="name" label="名称" >
          <template slot-scope="scope">
            <a @click="handleDetail(scope.row)" class="link">{{scope.row.name}}</a>
          </template>
        </el-table-column>
        <el-table-column prop="code" label="状态">
          <template slot-scope="scope">
            <el-switch
              v-model="scope.row.status"
              active-value="0"
              inactive-value="1"
              @change="changeCooStatus($event, scope.row)">
            </el-switch>
          </template>
        </el-table-column>
        <el-table-column prop="createTime" label="创建时间">
          <template slot-scope="scope">
            {{scope.row.createTime}}
          </template>
        </el-table-column>
        <el-table-column prop="remark" label="备注"></el-table-column>
        <el-table-column label="操作" fixed="right" width="120">
          <template slot-scope="scope">
            <el-button
              size="mini"
              type="text"
              icon="el-icon-edit"
              @click.native.stop="handleEdit('cooperate', scope.row)"
            >编辑
            </el-button>
            <el-button
              size="mini"
              type="text"
              icon="el-icon-delete"
              @click.native.stop="handleDel('cooperate', scope.row)"
            >删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <!-- <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pageNum"
        :page-sizes="[5, 10, 20, 30, 40]"
        :page-size="pageSize"
        layout="->, total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination> -->
    </div>
    <!-- 新增修改协同定义对话框 -->
    <el-dialog v-dialog-drag
      :title="title"
      :visible.sync="dialogFormVisible"
      :append-to-body="true"
      width="30%"
    >
      <el-form
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        label-width="60px"
        class="demo-ruleForm"
        label-position="left"
      >
        <el-form-item label="名称" prop="name">
          <el-input v-model="ruleForm.name" placeholder="请输入名称"></el-input>
        </el-form-item>
        <el-form-item label="备注" prop="remark">
          <el-input type="textarea" v-model="ruleForm.remark" placeholder="请输入备注"></el-input>
        </el-form-item>

      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitForm('ruleForm')" :loading="isLoading">确 定</el-button>
      </div>
    </el-dialog>
    <!-- 协同定义详情对话框 -->
    <el-dialog v-dialog-drag
      :title="cooperateInfo.name"
      :visible.sync="dialogCooperateConfig"
      :append-to-body="true"
      width="80%"
    >
      <div style="margin-bottom: 10px">
        <el-button type="primary" plain icon="el-icon-plus" @click="handleAdd('config')" size="small">新建</el-button>
<!--        <el-button icon="el-icon-edit-outline" plain type="success" :disabled="ids.length != 1" @click="handleEdit('config')" size="small">编辑</el-button>-->
<!--        <el-button type="danger" plain size="small" icon="el-icon-delete" :disabled="!ids.length" @click="handleDel('config')">删除</el-button>-->
      </div>
      <el-table
        :data="cooConfigList"
        tooltip-effect="dark"
        style="width: 100%"
        @selection-change="handleSelectionChange"
        :header-cell-style="{ background: '#F9F9FB', color: '#606266' }"
        v-loading="loading"
        row-key="id"
        :default-expand-all="true"
        :tree-props="{children: 'children', hasChildren: 'hasChildren'}"
      >
        <el-table-column prop="cfFlowWorkName" label="流程" >
          <!-- <template slot-scope="scope">
            <a @click="handleDetail(scope.row)" class="link">{{scope.row.name}}</a>
          </template> -->
        </el-table-column>
        <el-table-column prop="ofrThingName" label="单据负责人" >
          <!-- <template slot-scope="scope">
            <a @click="handleDetail(scope.row)" class="link">{{scope.row.name}}</a>
          </template> -->
        </el-table-column>
        <el-table-column prop="afterday" label="后推天数"></el-table-column>
        <el-table-column prop="sort" label="排序"></el-table-column>
        <el-table-column prop="createTime" label="创建时间">
          <template slot-scope="scope">
            {{scope.row.createTime}}
          </template>
        </el-table-column>
        <el-table-column prop="remark" label="备注"></el-table-column>
        <el-table-column label="操作" fixed="right" width="120">
          <template slot-scope="scope">
            <el-button
              size="mini"
              type="text"
              icon="el-icon-plus"
              @click.native.stop="handleAddChildren(scope.row)"
            >
            </el-button>
            <el-button
              size="mini"
              type="text"
              icon="el-icon-edit"
              @click.native.stop="handleEdit('config', scope.row)"
            >
            </el-button>
            <el-button
              size="mini"
              type="text"
              icon="el-icon-delete"
              @click.native.stop="handleDel('config', scope.row)"
            >
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogCooperateConfig = false">关 闭</el-button>
      </div>
    </el-dialog>
    <!-- 新增修改协同配置对话框 -->
    <el-dialog v-dialog-drag
      :title="title"
      :visible.sync="dialogCooConfigForm"
      :append-to-body="true"
      width="30%"
    >
      <el-form
        :model="cooConfigForm"
        :rules="cooConfigRules"
        ref="cooConfigForm"
        label-width="80px"
        class="demo-ruleForm"
        label-position="left"
      >
        <el-form-item label="流程" prop="cfFlowWorkId">
          <!-- <el-input v-model="ruleForm.name" placeholder="请输入名称"></el-input> -->
          <treeselect v-model="cooConfigForm.cfFlowWorkId" :options="cflowItemTree" :normalizer="normalizer" placeholder="请选择流程" :disable-branch-nodes="true" :flat="true"/>
        </el-form-item>
        <el-form-item label="后推天数" prop="afterday">
          <el-input type="number" v-model="cooConfigForm.afterday" placeholder="请输入后推天数"></el-input>
        </el-form-item>
        <el-form-item label="排序" prop="sort">
          <el-input type="number" v-model="cooConfigForm.sort" placeholder="请输入排序"></el-input>
        </el-form-item>
        <el-form-item label="负责人" prop="ofrThingId">
          <el-select v-model="cooConfigForm.ofrThingId" placeholder="请选择单据负责人" style="width: 100%" clearable>
            <el-option v-for="item in userList" :key="item.ofrThingId" :value="item.ofrthingId" :label="item.ofrthingName"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="备注" prop="remark">
          <el-input type="textarea" v-model="cooConfigForm.remark" placeholder="请输入备注"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogCooConfigForm = false">取 消</el-button>
        <el-button type="primary" @click="submitForm('cooConfigForm')" :loading="isLoading">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import url from '@/config/url'
import DictTag from '@/components/DictTag.vue'
import {mapState} from 'vuex'
import qs from 'qs'
import Treeselect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
  export default {
    computed: {
      ...mapState({
        dropDown: (state) => state.dropDown.dropDown
      })
    },
    components: {
      DictTag,
      Treeselect
    },
    data() {
      return {
        formInline: {
          name: null
        },
        tableData: [],
        loading: true,
        dialogFormVisible: false,
        ruleForm: {
          name: '',
          remark: ''
        },
        rules: {
          name: [{ required: true, message: "请输入名称", trigger: "submit" }],
        },
        // 弹出层标题
        title: '',
        isLoading: false,
        ids: [],
        cooperateInfo: {},
        dialogCooperateConfig: false,
        cooConfigList: [],
        dialogCooConfigForm: false,
        cooConfigForm: {
          cfFlowWorkId: null,
          afterday: null,
          sort: null,
          remark: null,
          ofrThingId: null
        },
        cooConfigRules: {
          cfFlowWorkId: [{ required: true, message: "请选择流程", trigger: "submit" }],
          afterday: [{ required: true, message: "请输入后推天数", trigger: "submit" }],
          sort: [{ required: true, message: "请输入排序", trigger: "submit" }],
        },
        cflowItemTree: [],
        userList: []
      }
    },
    created () {
      this.getList()
      this.$http.get(url.getCflowItemTree).then(res => {
        if(res.data.code == 200) {
          this.cflowItemTree = res.data.data
          this.cflowItemTree.forEach(process => {
            process.isDisabled = true
            if(process.children) {
              process.children.forEach(deal => {
                deal.isDisabled = true
              })
            }
          })
        }
      })
      this.userList = []
      this.$http.get(url.getDeptAndUser).then(res => {
        if(res.data.code == 200){
          const deptUser = res.data.data
          if(deptUser) {
            for (let i = 0; i < deptUser.length; i++) {
              if(deptUser[i].owhThingList) {
                for (let j = 0; j < deptUser[i].owhThingList.length; j++) {
                  this.userList.push({ ...deptUser[i].owhThingList[j], cbOwhId: deptUser[i].cbOwhId })
                }
              }
            }
          }
        }
      })
    },
    methods: {
      getList() {
        this.loading = true
        this.$http.get(url.cooperateList, {params: this.formInline,
          // pageNum: this.pageNum,
          // pageSize: this.pageSize
        }).then(res => {
          this.loading = false
          if(res.data.code == 200) {
            // console.log(res);
            this.tableData = res.data.data
            // this.total = res.data.data.total
          }
        })
      },
      // 提交表单
      submitForm(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            this.isLoading = true
            if(formName == 'ruleForm') {
              // 新增协同定义
              if(!this.ruleForm.id) {
                this.$http.post(url.addCooperate, this.ruleForm).then(res => {
                  // console.log(res);
                  this.isLoading = false
                  if(res.data.code === 200) {
                    this.$message.success(res.data.msg);
                    this.dialogFormVisible = false;
                    this.getList()
                  }
                })
              }else { // 编辑协同定义
                this.$http.post(url.editCooperate, this.ruleForm).then(res => {
                  // console.log(res);
                  this.isLoading = false
                  if(res.data.code === 200) {
                    this.$message.success(res.data.msg);
                    this.dialogFormVisible = false;
                    this.getList()
                  }
                })
              }
            }else {
              // 新增协同配置
              if(!this.cooConfigForm.id) {
                this.$http.post(url.addCooperateConfig, this.cooConfigForm).then(res => {
                  // console.log(res);
                  this.isLoading = false
                  if(res.data.code === 200) {
                    this.$message.success(res.data.msg);
                    this.dialogCooConfigForm = false;
                    this.getCooConfigList()
                  }
                })
              }else { // 编辑协同配置
                this.$http.post(url.editCooperateConfig, this.cooConfigForm).then(res => {
                  // console.log(res);
                  this.isLoading = false
                  if(res.data.code === 200) {
                    this.$message.success(res.data.msg);
                    this.dialogCooConfigForm = false;
                    this.getCooConfigList()
                  }
                })
              }
            }

          } else {
            return false;
          }
        });
      },
      // 切换协同定义状态
      changeCooStatus(e, row) {
        this.$http.post(`${url.changeCooCtatus}${row.id}/${e}`).then(res => {
          if(res.data.code == 200) {
            this.$message.success('状态修改成功');
          }else {
            row.status = row.status == '0' ? '1' : '0'
          }
        }).catch(err => {

        })
      },
      // 新增
      handleAdd(type) {
        if(type == 'cooperate') {
          this.dialogFormVisible = true
          this.title = '新增协同定义'
          this.$nextTick(() => {
          // 清除表单校验效果
            this.$refs.ruleForm.clearValidate();
          })
          // 初始化表单内容
          for(let key in this.ruleForm) {
            this.ruleForm[key] = null
          }
          this.ruleForm.status = '1'
        }else {
          this.dialogCooConfigForm = true
          this.title = '新增协同配置'
          this.$nextTick(() => {
          // 清除表单校验效果
            this.$refs.cooConfigForm.clearValidate();
          })
          // 初始化表单内容
          for(let key in this.cooConfigForm) {
            this.cooConfigForm[key] = null
          }
          this.cooConfigForm.cooperateId = this.cooperateInfo.id
          this.cooConfigForm.orgId = this.cooperateInfo.orgId
          this.cooConfigForm.afterday = 0
          this.cooConfigForm.pid = 0
        }

      },
      // 新增
      handleAddChildren(row) {
          this.dialogCooConfigForm = true
          this.title = '新增协同配置'
          this.$nextTick(() => {
          // 清除表单校验效果
            this.$refs.cooConfigForm.clearValidate();
          })
          // 初始化表单内容
          for(let key in this.cooConfigForm) {
            this.cooConfigForm[key] = null
          }
          this.cooConfigForm.cooperateId = this.cooperateInfo.id
          this.cooConfigForm.orgId = this.cooperateInfo.orgId
          this.cooConfigForm.afterday = 0
          this.cooConfigForm.pid = row.id
      },
      // 修改
      handleEdit(type, row) {
        if(type == 'cooperate') {
          if(this.$refs.ruleForm) {
            this.$nextTick(() => {
              // 清除表单校验效果
              this.$refs.ruleForm.clearValidate();
            })
          }
          let id = row?.id || this.ids[0]
          // console.log(row);
          this.dialogFormVisible = true
          this.title = '修改协同定义'
          this.$http.get(url.cooperateInfo + id).then(res => {
            // console.log(res);
            this.ruleForm = res.data.data
          })
        }else {
          if(this.$refs.cooConfigForm) {
            this.$nextTick(() => {
              // 清除表单校验效果
              this.$refs.cooConfigForm.clearValidate();
            })
          }
          let id = row?.id || this.ids[0]
          // console.log(row);
          this.dialogCooConfigForm = true
          this.title = '修改协同配置'
          this.$http.get(url.cooperateConfigInfo + id).then(res => {
            // console.log(res);
            this.cooConfigForm = res.data.data
          })
        }

      },
      // 删除
      handleDel(type, row) {
        let ids = row?.id || this.ids.toString()
        this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {

          if(type == 'cooperate') {
            this.$http.post(url.removeCooperate + ids).then(res => {
              if(res.data.code === 200) {
                this.$message({
                  type: 'success',
                  message: '删除成功!'
                });
                this.getList()
              }
            })
          }else {
            this.$http.post(url.removeCooperateConfig + ids).then(res => {
              if(res.data.code === 200) {
                this.$message({
                  type: 'success',
                  message: '删除成功!'
                });
                this.getCooConfigList()
              }
            })
          }

        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
        });
      },
      // 查看详情
      handleDetail(row) {
        this.cooperateInfo = row
        this.dialogCooperateConfig = true
        this.getCooConfigList()
      },
      getCooConfigList() {
        this.loading = true
        this.$http.get(url.cooperateConfigList, {params: {cooperateId: this.cooperateInfo.id}}).then(res => {
          this.loading = false
          if(res.data.code == 200) {
            // console.log(res);
            this.cooConfigList = res.data.data
            // this.total = res.data.data.total
          }
        })
      },
      // 查询按钮
      inquire() {
        this.pageNum = 1
        this.getList()
      },
      // 重置按钮
      reset() {
        for(let key in this.formInline) {
          this.formInline[key] = ""
        }
        this.pageNum = 1
        this.getList()
      },
      // 选择框事件
      handleSelectionChange(rows) {
        this.ids = rows.map(item => item.id)
      },

      /** 转换数据结构 */
      normalizer(node) {
        // this.$nextTick(() => {
          if (node.children == null || node.children.length == 0) {
            delete node.children;
          }
          // console.log(node.typeLevel);
          // return {
          //   id: node.cbOwhId,
          //   label: node.name,
          //   children: node.children
          // };
        // })
      },
    },
  }
</script>

<style lang="scss" scoped>
.approval {
  /* padding: 16px; */
  .sift, .main {
    background: #FFFFFF;
    box-shadow: 2px 3px 8px 0px rgba(208,208,208,0.5);
    border-radius: 11px;
    padding: 16px;
    position: relative;
    margin-bottom: 16px;
    .el-table {
      margin-bottom: 39px;
    }
  }
  .main {
    margin-bottom: 0;
  }
  .title {
    height: 14px;
    font-size: 14px;
    font-family: STHeitiSC-Medium, STHeitiSC;
    font-weight: 500;
    color: #282828;
    line-height: 14px;
    padding-left: 8px;
    border-left: #0c75e5 2px solid;
    margin-bottom: 16px;
    font-weight: bolder;
  }
}
</style>
